import script from "./UsdmanView.vue?vue&type=script&setup=true&lang=js"
export * from "./UsdmanView.vue?vue&type=script&setup=true&lang=js"

import "./UsdmanView.vue?vue&type=style&index=0&id=d758053a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d758053a"]])

export default __exports__